"use client";

import "@/styles/globals.css";

import NextNProgress from "nextjs-progressbar";
import { brandingHslToHex, getBrandingLight } from "@/lib/branding-hsl";
import setupLogRocketReact from "logrocket-react";
import LogRocket from "logrocket";
import { Suspense, useEffect, useRef, type ReactNode } from "react";
import { NotificationsProvider } from "@/hooks/NotificationsProvider";
import { AuthProvider } from "@/providers/auth.provider";
import { CharityThemeProvider } from "@/components/theme-provider";
import { DesignSystemInit } from "@/components/design-system-init";
import { Toaster } from "@gogive/design-system";
import { PostHogProvider } from "@/components/posthog-provider";

export function AppProviders({ children }: { children: ReactNode }) {
  const logRocketRef = useRef<boolean>(false);

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      !logRocketRef.current &&
      process.env.NEXT_PUBLIC_STAGE === "prod"
    ) {
      LogRocket.init("u0bgqp/gogive-charity-portal", {
        dom: {
          inputSanitizer: true,
        },
      });
      setupLogRocketReact(LogRocket);
      logRocketRef.current = true;
    }
  }, []);

  return (
    <PostHogProvider>
      <Suspense fallback={null}>
        <CharityThemeProvider>
          <DesignSystemInit>
            <AuthProvider>
              <NotificationsProvider>
            <NextNProgress
              color={brandingHslToHex(getBrandingLight().primary)}
              startPosition={0.3}
              stopDelayMs={200}
              height={3}
              showOnShallow
              options={{ easing: "ease", speed: 500 }}
            />
            <style jsx global>{`
              html {
                max-height: 100vh;
              }
              body {
                margin: 0px;
              }
              * {
                box-sizing: border-box;
              }
            `}</style>
            <Toaster position="bottom-right" />
            {children}
              </NotificationsProvider>
            </AuthProvider>
          </DesignSystemInit>
        </CharityThemeProvider>
      </Suspense>
    </PostHogProvider>
  );
}
